<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_022"><img alt="Image" src="images/f0013-01.jpg"/></a></p><a id="file_022">
<p class="caption">Grumman’s first fighter was so unique and revolutionary that the company built a model to wow the navy brass. The life-size mock-up, made of wood, was open on the back side to allow viewers to see the inner workings of the plane. Note the gunner’s station in the rear cockpit. <em>Grumman History Center</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_022.vue?0a15b409